<template>
  <div id="searchTourscope" class="shadow">
    <load-area
      v-if="
        countries == null ||
          departureCities == null ||
          operators == null ||
          hotels == null
      "
    ></load-area>
    <Form
      method="dialog"
      v-slot="{ errors }"
      class="floating-labels"
      ref="form"
      v-if="
        countries != null &&
          departureCities != null &&
          operators != null &&
          hotels != null
      "
    >
      <div class="toggle open">
        <div class="center">
          <div class="row">
            <div class="col">
              <selectBox
                :title="'Country'"
                :as="'select'"
                v-model="countryId"
                :errors="errors"
              >
                <template #search>
                  <input
                    type="text"
                    placeholder="Search..."
                    class="form-control small"
                    v-model="searchCountry"
                  />
                </template>
                <template #inputCustom>
                  <template v-for="item in countries">
                    <li
                      :value="item.Id"
                      :key="item.Id"
                      v-if="
                        item.Name.toLowerCase().indexOf(
                          searchCountry.toLowerCase()
                        ) > -1
                      "
                      :class="{ selected: countryId == item.Id }"
                      @click="
                        countryId == item.Id
                          ? (countryId = null)
                          : (countryId = item.Id);
                        $refs.form.validateField('Oparatör');
                      "
                    >
                      <span
                        class="flag-icon"
                        :class="'flag-icon-' + item.ISO2.toLowerCase()"
                      ></span>
                      {{ item.Name }}
                    </li>
                  </template>
                </template>
              </selectBox>
            </div>
            <div class="col">
              <selectBox
                :title="'Departure Cities'"
                :as="'select'"
                v-model="model.DepartureCities"
                :errors="errors"
                :rules="{ required: true }"
              >
                <template #search>
                  <input
                    type="text"
                    placeholder="Search..."
                    class="form-control small"
                    v-model="searchDepartureCities"
                  />
                  <ul v-if="model.DepartureCities.length > 0">
                    <li @click="model.DepartureCities = []">Sıfırla</li>
                  </ul>
                </template>
                <template #inputCustom>
                  <template v-for="item in departureCities">
                    <li
                      class="myCheckBox"
                      :key="item.Id"
                      v-if="
                        item.Name.toLowerCase().indexOf(
                          searchDepartureCities.toLowerCase()
                        ) > -1 &&
                          (countryId == null || countryId == item.CountryId)
                      "
                    >
                      <input
                        type="checkbox"
                        class="filled-in chk-col-teal"
                        :checked="model.DepartureCities.indexOf(item.Id) > -1"
                      />
                      <label
                        :for="'hotel' + item.Id"
                        @click="
                          model.DepartureCities.indexOf(item.Id) > -1
                            ? (model.DepartureCities = model.DepartureCities.filter(
                                (x) => x != item.Id
                              ))
                            : model.DepartureCities.push(item.Id)
                        "
                      >
                        {{ item.Name }}
                      </label>
                    </li>
                  </template>
                </template>
              </selectBox>
            </div>
            <div class="col">
              <selectBox
                :title="'Operators'"
                :as="'select'"
                v-model="model.Operators"
                :errors="errors"
                :rules="{ required: true }"
              >
                <template #search>
                  <input
                    type="text"
                    placeholder="Search..."
                    class="form-control small"
                    v-model="searchOperators"
                  />
                  <ul v-if="model.Operators.length > 0">
                    <li @click="model.Operators = []">Sıfırla</li>
                  </ul>
                </template>
                <template #inputCustom>
                  <template v-for="item in operators">
                    <li
                      class="myCheckBox"
                      :key="item.Id"
                      v-if="
                        item.Name.toLowerCase().indexOf(
                          searchOperators.toLowerCase()
                        ) > -1
                      "
                    >
                      <input
                        type="checkbox"
                        class="filled-in chk-col-teal"
                        :checked="model.Operators.indexOf(item.Id) > -1"
                      />
                      <label
                        :for="'hotel' + item.Id"
                        @click="
                          model.Operators.indexOf(item.Id) > -1
                            ? (model.Operators = model.Operators.filter(
                                (x) => x != item.Id
                              ))
                            : model.Operators.push(item.Id)
                        "
                      >
                        {{ item.Name }}
                      </label>
                    </li>
                  </template>
                </template>
              </selectBox>
            </div>
            <div class="col">
              <selectBox
                :title="'Hotels'"
                :as="'select'"
                v-model="model.Hotels"
                :errors="errors"
                :rules="{ required: true }"
              >
                <template #search>
                  <input
                    type="text"
                    placeholder="Search..."
                    class="form-control small"
                    v-model="searchHotels"
                  />
                  <ul v-if="model.Hotels.length > 0">
                    <li @click="model.Hotels = []">Sıfırla</li>
                  </ul>
                </template>
                <template #inputCustom>
                  <template v-for="item in hotels">
                    <li
                      class="myCheckBox"
                      :key="item.Id"
                      v-if="
                        item.Name.toLowerCase().indexOf(
                          searchHotels.toLowerCase()
                        ) > -1
                      "
                    >
                      <input
                        type="checkbox"
                        class="filled-in chk-col-teal"
                        :checked="model.Hotels.indexOf(item.Id) > -1"
                      />
                      <label
                        :for="'hotel' + item.Id"
                        @click="
                          model.Hotels.indexOf(item.Id) > -1
                            ? (model.Hotels = model.Hotels.filter(
                                (x) => x != item.Id
                              ))
                            : model.Hotels.push(item.Id)
                        "
                      >
                        {{ item.Name }}
                      </label>
                    </li>
                  </template>
                </template>
              </selectBox>
            </div>
            <div class="col">
              <selectBox
                :title="'Durations'"
                :as="'select'"
                v-model="model.Durations"
                :errors="errors"
                :rules="{ required: true }"
              >
                <template #search>
                  <input
                    type="number"
                    placeholder="Search..."
                    class="form-control small"
                    v-model="searchDurations"
                  />
                  <ul v-if="model.Durations.length > 0">
                    <li @click="model.Durations = []">Sıfırla</li>
                  </ul>
                </template>
                <template #inputCustom>
                  <template v-for="item in 21">
                    <li
                      class="myCheckBox"
                      :key="item"
                      v-if="searchDurations == '' || searchDurations == item"
                    >
                      <input
                        type="checkbox"
                        class="filled-in chk-col-teal"
                        :checked="model.Durations.indexOf(item) > -1"
                      />
                      <label
                        :for="'hotel' + item.Id"
                        @click="
                          model.Durations.indexOf(item) > -1
                            ? (model.Durations = model.Durations.filter(
                                (x) => x != item
                              ))
                            : model.Durations.push(item)
                        "
                      >
                        {{ item }}
                      </label>
                    </li>
                  </template>
                </template>
              </selectBox>
            </div>
          </div>
        </div>
      </div>
      <div class="action row align-items-center">
        <div class="col">
          <formGroup
            :title="'StartDate'"
            type="date"
            v-model="model.StartDate"
            :errors="errors"
            @keydown.enter="get"
          ></formGroup>
        </div>
        <div class="col">
          <formGroup
            :title="'EndDate'"
            type="date"
            v-model="model.EndDate"
            :errors="errors"
            @keydown.enter="get"
          ></formGroup>
        </div>
        <div class="col-auto">
          <Btn
            class="btn btn-warning waves-effect text-left"
            @click="get"
            :process="data == null"
            ><span class="p-l-20 p-r-20">GET</span>
          </Btn>
        </div>
      </div>
    </Form>
  </div>
  <div class="card m-t-20" v-if="data != false">
    <dataTable
      :name="'SearchMinPrices'"
      :columnDefs="columnDefs"
      ref="agGrid"
      :data="data"
    ></dataTable>
  </div>
  <!-- <report :Commission="Commission" :CurrencyId="CurrencyId"></report> -->
</template>

<script>
import selectBox from "../../../components/formGroup/selectBox.vue";
import moment from "moment";
export default {
  name: "SearchMinPrices",
  components: { selectBox },
  data() {
    return {
      countries: null,
      searchCountry: "",
      countryId: null,
      departureCities: null,
      searchDepartureCities: "",
      operators: null,
      searchOperators: "",
      hotels: null,
      searchHotels: "",
      searchDurations: "",
      model: {
        StartDate: "",
        EndDate: "",
        Durations: [],
        Hotels: [],
        Operators: [],
        DepartureCities: [],
      },
      data: false,
      columnDefs: [
        {
          headerName: "HotelName",
          field: "HotelName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "PriceKey",
          field: "PriceKey",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "OperatorId",
          field: "OperatorId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "DepartureCityId",
          field: "DepartureCityId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Checkin",
          field: "Checkin",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
          valueFormatter: function(params) {
            if (params.value == null) {
              return null;
            } else {
              return moment(new Date(params.value)).format("DD.MM.YYYY");
            }
          },
        },
        {
          headerName: "Duration",
          field: "Duration",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "HotelId",
          field: "HotelId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "DBLRoom",
          field: "DBLRoom",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "DBLMeal",
          field: "DBLMeal",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "DBLCHDRoom",
          field: "DBLCHDRoom",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "DBLCHDMeal",
          field: "DBLCHDMeal",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "PackageRoom",
          field: "PackageRoom",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "PackageMeal",
          field: "PackageMeal",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "PP",
          field: "PP",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Daily",
          field: "Daily",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "DBL",
          field: "DBL",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "DBLCHD",
          field: "DBLCHD",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Package",
          field: "Package",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Flight",
          field: "Flight",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "CurrencyCode",
          field: "CurrencyCode",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "USD",
          field: "USD",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "EUR",
          field: "EUR",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Adult",
          field: "Adult",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Childs",
          field: "Childs",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Age1",
          field: "Age1",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Age2",
          field: "Age2",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Age3",
          field: "Age3",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Age4",
          field: "Age4",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "LastUpdate",
          field: "LastUpdate",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
          valueFormatter: function(params) {
            if (params.value == null) {
              return null;
            } else {
              return moment(new Date(params.value)).format(
                "DD.MM.YYYY - HH:mm"
              );
            }
          },
        },
      ],
    };
  },
  created() {
    this.$appAxiosAdmin.get(`Countries`).then((response) => {
      this.countries = response.data;
    });
    this.getValues();
    var nowDate = new Date();
    this.model.StartDate = this.$moment(nowDate).format("YYYY-MM-DD");
    nowDate.setDate(nowDate.getDate() + 6);
    this.model.EndDate = this.$moment(nowDate).format("YYYY-MM-DD");
  },
  methods: {
    getValues() {
      this.$appAxiosAdmin.get(`TOURSCOPE/DepartureCities`).then((response) => {
        this.departureCities = response.data;
      });
      this.$appAxiosAdmin.get(`OperatorsNames`).then((response) => {
        this.operators = response.data;
      });
      this.$appAxiosAdmin.get(`Hotels/Country/228`).then((response) => {
        this.hotels = response.data.filter((x) => x.MatchCount > 0);
      });
    },
    get() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.data = null;
          this.$appAxiosTourscope
            .post(`Helpers/SearchMinPrices`, {
              ...this.model,
              StartDate:
                this.model.StartDate == "" ? null : this.model.StartDate,
              EndDate: this.model.EndDate == "" ? null : this.model.EndDate,
            })
            .then((response) => {
              this.data = response.data;
            })
            .catch((err) => {
              this.$isError(err);
              this.data = false;
            });
        }
      });
    },
  },
  computed: {},
};
</script>

<style scoped>
#searchTourscope .action /deep/ .form-group {
  margin-bottom: 0;
}
</style>
